import React, { Component } from 'react'
import { deburr } from 'lodash'

import {
  Button,
  OptionContainer,
  Input,
  ScrollContainer,
  Label,
  Container,
} from './styles'
import { Arrow } from '@icons'

class NeighborhoodFilter extends Component {
  constructor() {
    super()
    this.state = {
      options: [],
      search: '',
      active: false,
    }

    this.lastOption = 0
    this.currentOption = null
  }

  componentDidMount() {
    this.setOptions()
    document.addEventListener('mousedown', this.handleClick, false)
  }

  componentDidUpdate(_, prevState) {
    const { active } = this.state

    if (prevState.active && !active) {
      document.removeEventListener('keydown', this.handleKeyDown, false)
    }

    if (!prevState.active && active) {
      document.addEventListener('keydown', this.handleKeyDown, false)
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick, false)
    document.removeEventListener('keydown', this.handleKeyDown, false)
  }

  handleClick = e => {
    if (
      (this.node && this.node.contains(e.target)) ||
      this.button.contains(e.target)
    ) {
      return
    }

    this.state.active && this.toggleContainer()
  }

  handleKeyDown = ({ key, preventDefault }) => {
    const { options } = this.state

    if (key === 'ArrowDown') {
      preventDefault()
      this.currentOption += 1
      document
        .getElementById(`option${options[this.currentOption]?.label}`)
        ?.focus()
    }

    if (key === 'ArrowUp') {
      preventDefault()
      this.currentOption -= 1
      document
        .getElementById(`option${options[this.currentOption]?.label}`)
        ?.focus()
    }

    if (key === 'Enter') {
      const { value, label } = options[this.currentOption]

      this.handleOptionClick(value, label)
    }

    if (this.currentOption < 0) {
      this.currentOption = 0
    } else if (this.currentOption > this.lastOption) {
      this.currentOption = this.lastOption
    }
  }

  toggleContainer = () => {
    const { active } = this.state

    this.currentOption = -1
    this.setState({ active: !active })
  }

  setOptions = () => {
    const { options = [] } = this.props

    this.setState({ options: [...options] })
    this.lastOption = options.length - 1
    this.currentOption = -1
  }

  onOptionSearch = ({ target: { value } }) => {
    const { options } = this.props

    const updateOptionCount = () => {
      const { options } = this.state

      this.currentOption = -1
      this.lastOption = options.length - 1
    }

    if (value) {
      this.setState(
        {
          search: value,
          options: options.filter(({ label }) =>
            deburr(label)
              .toLowerCase()
              .includes(deburr(value).toLowerCase()),
          ),
        },
        updateOptionCount,
      )
    } else {
      this.setState(
        {
          search: value,
          options: [...options],
        },
        updateOptionCount,
      )
    }
  }

  handleFilterClick = () => {
    this.toggleContainer()
    setTimeout(() => {
      this.input && this.input.focus()
    }, 500)
  }

  handleOptionClick = (value, label) => {
    const { onChange = () => null } = this.props

    onChange(value, label)
    this.toggleContainer()
    this.currentOption = null
  }

  render() {
    const { options, search, active } = this.state
    const { selectedNeighborhood } = this.props

    return (
      <Container>
        <Button
          ref={el => (this.button = el)}
          onClick={this.handleFilterClick}
          type="button"
        >
          <Label>{selectedNeighborhood || 'Bairros'}</Label>
          <Arrow />
        </Button>
        {active && (
          <OptionContainer ref={el => (this.node = el)}>
            <Input
              placeholder="Pesquise aqui"
              value={search}
              onChange={this.onOptionSearch}
              ref={el => (this.input = el)}
            />
            <ScrollContainer>
              {options.map(({ label, value }) => (
                <div
                  key={value}
                  id={`option${label}`}
                  tabIndex={0}
                  onClick={() => this.handleOptionClick(value, label)}
                >
                  {label}
                </div>
              ))}
            </ScrollContainer>
          </OptionContainer>
        )}
      </Container>
    )
  }
}

export default NeighborhoodFilter
